import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = () => {
  const token = localStorage.getItem("nc_admin_token");
  return axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

export const fetchProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const fetchProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const fetchReviews = (productId) => api.get(`/reviews/${productId}`).then((r) => r.data);
export const postReview = (data) => api.post("/reviews", data).then((r) => r.data);
export const createOrder = (data) => {
  const token = localStorage.getItem("nc_user_token");
  return api.post("/orders/create", data, { headers: token ? { Authorization: `Bearer ${token}` } : {} }).then((r) => r.data);
};
export const verifyPayment = (data) => api.post("/orders/verify", data).then((r) => r.data);
export const getConfig = () => api.get("/config").then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const validateCoupon = (code, subtotal) => api.post("/coupons/validate", { code, subtotal }).then((r) => r.data);
